// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero-module--container--QpLOb","title":"Hero-module--title--1rIA5","subtext":"Hero-module--subtext--1u5Yg"};